// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Atom_Cta = require("../design-system/atom/Atom_Cta.bs.js");
var Atom_Text = require("../design-system/atom/Atom_Text.bs.js");
var Atom_Loader = require("../design-system/atom/Atom_Loader.bs.js");
var Atom_Select = require("../design-system/atom/Atom_Select.bs.js");
var GlobalStyle = require("../design-system/GlobalStyle.bs.js");
var Atom_Checkbox = require("../design-system/atom/Atom_Checkbox.bs.js");
var Util_Particle = require("../util/Util_Particle.bs.js");
var Atom_Icon_Mona = require("../design-system/atom/icon/Atom_Icon_Mona.bs.js");
var Molecule_Modal = require("../design-system/molecule/Molecule_Modal.bs.js");
var User_Standalone = require("../user/User_Standalone.bs.js");
var Molecule_Message = require("../design-system/molecule/Molecule_Message.bs.js");
var Entry_Mona_Header = require("./Mona/Entry_Mona_Header.bs.js");
var Molecule_EventInfo = require("../design-system/molecule/Molecule_EventInfo.bs.js");
var Atom_Textfield_Mona = require("../design-system/atom/Atom_Textfield_Mona.bs.js");
var Molecule_DatePicker = require("../design-system/molecule/Molecule_DatePicker.bs.js");

function globalStyle(withFont) {
  GlobalStyle.Mona.make(withFont, undefined);
}

Atom_Icon_Mona.make.displayName = "Icon";

Molecule_Message.make.displayName = "Message";

Atom_Loader.make.displayName = "Loader";

var Button = Atom_Cta.Mona.Button.make;

Button.displayName = "Button";

var Typography = Atom_Text.Mona.make;

Typography.displayName = "Typography";

var Textfield = Atom_Textfield_Mona.Mona.make;

Textfield.displayName = "Textfield";

var Link = Atom_Cta.Mona.Link.make;

Link.displayName = "Link";

var Dropdown = Atom_Select.Mona.make;

Dropdown.displayName = "Dropdown";

Molecule_Modal.make.displayName = "Modal";

var DatePicker = Molecule_DatePicker.Mona.make;

DatePicker.displayName = "DatePicker";

var Checkbox = Atom_Checkbox.Mona.make;

Checkbox.displayName = "Checkbox";

Molecule_EventInfo.make.displayName = "EventInfo";

Entry_Mona_Header.make.displayName = "Header";

var Icon = Atom_Icon_Mona.make;

var Message = Molecule_Message.make;

var Loader = Atom_Loader.make;

var spacers = Util_Particle.sizes;

var noneSpacer = Util_Particle.noneSize;

var xxsSpacer = Util_Particle.xxsSize;

var xsSpacer = Util_Particle.xsSize;

var sSpacer = Util_Particle.sSize;

var mSpacer = Util_Particle.mSize;

var lSpacer = Util_Particle.lSize;

var xlSpacer = Util_Particle.xlSize;

var Modal = Molecule_Modal.make;

var EventInfo = Molecule_EventInfo.make;

var Header = Entry_Mona_Header.make;

var getToken = User_Standalone.getTokenFromStorage;

exports.globalStyle = globalStyle;
exports.Icon = Icon;
exports.Message = Message;
exports.Loader = Loader;
exports.Button = Button;
exports.Typography = Typography;
exports.spacers = spacers;
exports.noneSpacer = noneSpacer;
exports.xxsSpacer = xxsSpacer;
exports.xsSpacer = xsSpacer;
exports.sSpacer = sSpacer;
exports.mSpacer = mSpacer;
exports.lSpacer = lSpacer;
exports.xlSpacer = xlSpacer;
exports.Textfield = Textfield;
exports.Link = Link;
exports.Dropdown = Dropdown;
exports.Modal = Modal;
exports.DatePicker = DatePicker;
exports.Checkbox = Checkbox;
exports.EventInfo = EventInfo;
exports.Header = Header;
exports.getToken = getToken;
/*  Not a pure module */
